var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDocSearch(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 34.625A1.128 1.128 0 019.875 33.5v-27c0-.619.506-1.125 1.125-1.125h11.25V11a2.248 2.248 0 002.25 2.25h5.625V33.5c0 .619-.506 1.125-1.125 1.125H11zM11 2a4.504 4.504 0 00-4.5 4.5v27c0 2.482 2.018 4.5 4.5 4.5h18c2.482 0 4.5-2.018 4.5-4.5V12.863a4.502 4.502 0 00-1.315-3.185l-6.37-6.363A4.485 4.485 0 0022.637 2H11zm14.625 21.375a6.752 6.752 0 00-6.75-6.75 6.752 6.752 0 00-6.75 6.75 6.752 6.752 0 006.75 6.75 6.73 6.73 0 003.424-.928l2.693 2.693a1.68 1.68 0 002.384 0c.654-.661.66-1.73 0-2.384l-2.693-2.693a6.699 6.699 0 00.935-3.438h.007zM18.875 20a3.375 3.375 0 110 6.75 3.375 3.375 0 010-6.75z",
    fill: "#fff"
  })));
}
export default SvgDocSearch;